import RoleLogic from "./logic";
const moduleHandler = (LocalStorage, roles) => {
  const role = RoleLogic(LocalStorage);
  return roles[role];
};

export default moduleHandler;
